import React from 'react';
import { SiCheckmarx } from "react-icons/si";
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import ServiceCards from "../../../components/ServiceCards/ServiceCards";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";

const GamingLicenseServices = () => {

    return (
        <main className='main'>

            <IntroSection
                title="iGaming & Gambling License – Western Sahara"
                subtitle="Launch Your Gaming Business with CRA Licensing"
                description =
                    "The <b>Capital Regulatory Authority (CRA)</b> of <b>Western Sahara</b> offers one of the <b>most affordable and flexible iGaming licenses</b> in the <b>offshore world</b>. With <b>no statutory capital requirements</b> and a <b>streamlined approval process</b>, the <b>CRA license</b> is an ideal choice for <b>online casinos</b>, <b>sportsbooks</b>, <b>lotteries</b>, and <b>crypto gaming operators</b>."
                badges={[
                    "Online Casino License",
                    "Sportsbook License",
                    "Lottery & Sweepstakes",
                    "eSports & Crypto Gaming",
                ]}
                buttonText="Request a Gaming License Proposal →"
                buttonLink="/contact"
                imageSrc="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop"
                imageAlt="Gaming License Intro"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Western Sahara?'
                        subtitle="Operating without a license exposes your business to:"
                        blocks={[
                            {
                                subtitle: "With a gaming license, you gain:",
                                items: [
                                    { icon: "✔️", title: "No Capital Requirement", description: "unlike Malta, Isle of Man, or Curaçao"},
                                    { icon: "✔️", title: "Fast Licensing", description: "approval within 4–8 weeks"},
                                    { icon: "✔️", title: "Global Reach", description: "operate worldwide under CRA framework"},
                                    { icon: "✔️", title: "Crypto-Friendly", description: "issue tokens, accept crypto payments, launch blockchain casinos"},
                                    { icon: "✔️", title: "Affordable Fees", description: "significantly lower than EU/Tier-1 gaming regulators"},
                                ]
                            }
                        ]}
                    />

                    <FeatureCards
                        title='What the License Covers'
                        subtitle='A CRA iGaming License in Western Sahara allows you to operate:'
                        features={
                            [
                                { title: "Online Casino", text: "slots, table games, live dealer, RNG platforms" },
                                { title: "Sportsbook & Betting", text: "fixed odds, live betting, eSports" },
                                { title: "Lottery & Sweepstakes", text: "online draws and number games" },
                                { title: "Poker & Skill Games", text: "tournaments, fantasy sports, games of skill" },
                                { title: "Crypto Gaming Platforms", text: "provably fair games, tokenized casinos, NFT integration" },
                                { title: "White-Label Solutions", text: "license covers sub-brands or multi-brand operations" }
                            ]
                        }
                    />

                    <LocationTimeline
                        title='Jurisdiction We Offer'
                        item={
                            [
                                { title: "Operate Globally", text: "CRA license recognized by providers & affiliates" },
                                { title: "Payment Access", text: "easier onboarding with crypto PSPs & EMIs" },
                                { title: "Marketing & Affiliates", text: "ability to advertise and join affiliate networks" },
                                { title: "Regulatory Oversight", text: "CRA-approved compliance ensures legitimacy" },
                                { title: "Flexibility", text: "add casino, betting, or crypto modules as your business grows" }
                            ]
                        }
                    />

                    {/* Services */}
                    <ServiceCards
                        title='Licensing Process'
                        services={
                            [
                                { title: "Consultation & Strategy", text: "define business model (casino, sportsbook, lottery, or hybrid)" },
                                { title: "Company Incorporation", text: "register your entity in Western Sahara under CRA" },
                                { title: "Documentation", text: "AML/KYC policies, risk frameworks, platform provider details" },
                                { title: "Application Submission", text: "Offshore Advisory files your CRA license application" },
                                { title: "Approval & Activation", text: "license granted, platform integration, PSP onboarding" }
                            ]
                        }
                    />

                    {/* Timeline */}
                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                description: "1–2 weeks (fast-track compared to EU regulators)",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Setup Costs",
                                description: "Starting from USD 16,000+",
                                duration: "6–10 months",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Annual Renewal Fees",
                                description: "Competitive vs. Curaçao or Malta",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Capital Requirement",
                                description: "None",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                { text: "Licensed CRA agent with iGaming experience" },
                                { text: "End-to-end service: incorporation, license application, compliance, PSP onboarding" },
                                { text: "Access to white-label casino & sportsbook platforms" },
                                { text: "Crypto payment & tokenization integration" },
                                { text: "Affiliate marketing support & partnerships" }
                            ]
                        }
                        />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    {/* Final CTA */}
                    <CTA title='Ready to launch your gaming platform?'
                         description=
                             "With <b>no capital requirements</b> and <b>fast approvals,</b> CRA in Western Sahara is one of the most efficient iGaming regulators worldwide."
                         buttonText='Book a CRA Gaming License Consultation →'
                         buttonLink='/quote'
                    />
                </div>
            </section>
        </main>
    );
};

export default GamingLicenseServices;

const faqData = [
    {
        question: "Is there a capital requirement for iGaming in Western Sahara?",
        content: [
            { type: "answer", text: "No — CRA licenses have no fixed capital requirement." },
        ],
    },
    {
        question: "How long does it take to get a license?",
        content: [
            { type: "answer", text: "Typically 1–2 weeks." },
        ],
    },
    {
        question: "Can I accept crypto payments?",
        content: [
            { type: "answer", text: "Yes — CRA is crypto-friendly, allowing BTC, ETH, USDT, and tokenized gaming." },
        ],
    },
    {
        question: "Can one license cover multiple gaming products?",
        content: [
            { type: "answer", text: "Yes — casino, sportsbook, lottery, and crypto gaming can be combined." },
        ],
    },
    {
        question: "Is the license globally recognized?",
        content: [
            { type: "answer", text: "Yes — while not EU-level (like Malta), CRA is widely accepted in offshore iGaming, particularly for PSPs, affiliates, and crypto payment providers." },
        ],
    },
];

const testimonialsData = [
    {
        quote:
            "We launched our sportsbook under a CRA license in 6 weeks. Offshore Advisory handled the application and payment integration seamlessly.",
        author: "Richard S.",
        role: "Sportsbook Founder",
    },
    {
        quote:
            "The CRA license allowed us to launch a crypto casino without heavy capital requirements. Perfect for startups.",
        author: "Elena  D.",
        role: "iGaming Entrepreneur",
    },
];